/**
 * Leo Brand Agent 建店工作台（Overseas patch 267）
 */
export const LEO_BRAND_ONBOARDING_MENU_IDS = {
  group: 990481,
  desk: 990482,
  view: 990483,
  confirm: 990484
}

export default LEO_BRAND_ONBOARDING_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/leoBrandOnboarding.js